import { render, staticRenderFns } from "./AiBookShelvesManage.vue?vue&type=template&id=456182a5&scoped=true"
import script from "./AiBookShelvesManage.vue?vue&type=script&lang=js"
export * from "./AiBookShelvesManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456182a5",
  null
  
)

export default component.exports